<template>
  <container>
    <alert type="success" v-model="comingSoon">{{ $lang.underConstruction }}</alert>
  </container>
</template>
<script>
export default {
  name: 'PageComingSoon',
  data () {
    return {
      comingSoon: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/coming-soon.vue